<div
  class="w-100"
  style="z-index: 1; padding: 0; pointer-events: all"
>
  <!--Opción 1-->
  <!-- <ul class="nav flex-column">
    <li class="nav-item">
      <button
        (click)="debugLayerClicked()"
        type="button"
        class="btn btn-outline-light"
      >
        <i class="fa fa-bug" aria-hidden="true"></i> Debug Layer
      </button>
    </li>
    <li class="nav-item" *ngFor="let item of menuItems">
      <app-menu-item
        [item]="item"
        (onClick)="childClick($event)"
      ></app-menu-item>
    </li>
  </ul> -->
  <!--Opción 2-->
  <!-- <app-menu-item
    *ngFor="let item of menuItems"
    [item]="item"
    (onClick)="childClick($event)"
  ></app-menu-item> -->

  <!--Opción 3-->
  <app-menu-item [items]="menuItems" [level]="0"></app-menu-item>
  <!-- (onClick)="childClick($event)" -->
</div>
<!-- <div
  [ngClass]="
    innerWidth < 480 ? 'position-relative z-index-1' : 'position-absolute'
  "
  class="w-100 text-center brand-info"
>
  <p class="m-0">SPG Digital Corp</p>
  <p class="m-0">E-mail: sebastian@spgdigitalcorp.com</p>
  <p class="m-0">Phone: +01 (305) 790-2129</p>
</div> -->
